import { useMutation } from '@apollo/client';
import NEW_COPIED_TEXT from 'graphql/fragments/NewCopiedText.graphql';
import CREATE_COPIED_TEXT from 'graphql/mutations/copiedTexts/CreateCopiedText.graphql';

export default function useCreateCopiedTextMutation() {
  return useMutation(CREATE_COPIED_TEXT, {
    update(cache, { data: { createCopiedText } }) {
      cache.modify({
        fields: {
          copiedTextsByEpub(existingCopiedTexts) {
            const newCopiedTextRef = cache.writeFragment({
              data: createCopiedText.copiedText,
              fragment: NEW_COPIED_TEXT,
            });

            return {
              __typename: existingCopiedTexts.__typeName,
              edges: [
                ...existingCopiedTexts.edges,
                {
                  __typename: 'CopiedTextNodeEdge',
                  node: newCopiedTextRef,
                },
              ],
            };
          },
        },
      });
    },
  });
}
